export default [
  {
    path: '/apolices',
    redirect: { name: 'painel-honorarios' },
  },
  {
    path: '/apolices/configuracoes',
    name: 'config-apolices',
    component: () => import('./ConfigApolices.vue'),
    meta: {
      resource: 'cadastroapolice',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'config-apolices',
      pageTitle: 'Configurações de Apólices',
      breadcrumb: [
        {
          text: 'Apólices',
          to: { name: 'config-apolices' },
          active: true,
        },
      ],
    },
  },
  {
    path: '/apolices/configuracoes/gerais/novo',
    name: 'nova-apolice-geral',
    component: () => import('./shared/components/cadastro/ApoliceGeralCadastro.vue'),
    meta: {
      resource: 'cadastroapolice',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'config-apolices',
      pageTitle: 'Cadastro de apólice',
      breadcrumb: [
        {
          text: 'Apólices',
          to: { name: 'config-apolices' },
        },
        {
          text: 'Nova apólice',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apolices/configuracoes/gerais/editar/:id',
    name: 'editar-apolice-geral',
    component: () => import('./shared/components/cadastro/ApoliceGeralCadastro.vue'),
    meta: {
      resource: 'cadastroapolice',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'config-apolices',
      pageTitle: 'Cadastro de apólice',
      breadcrumb: [
        {
          text: 'Apólices',
          to: { name: 'config-apolices' },
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apolices/configuracoes/individuais/novo',
    name: 'nova-apolice-individual',
    component: () => import('./shared/components/cadastro/ApoliceIndividualCadastro.vue'),
    meta: {
      resource: 'cadastroapolice',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'config-apolices',
      pageTitle: 'Cadastro de apólice',
      breadcrumb: [
        {
          text: 'Apólices',
          to: { name: 'config-apolices' },
        },
        {
          text: 'Nova apólice',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apolices/configuracoes/individuais/editar/:id',
    name: 'editar-apolice-individual',
    component: () => import('./shared/components/cadastro/ApoliceIndividualCadastro.vue'),
    meta: {
      resource: 'cadastroapolice',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'config-apolices',
      pageTitle: 'Cadastro de apólice',
      breadcrumb: [
        {
          text: 'Apólices',
          to: { name: 'config-apolices' },
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
    },
  },
]
